const EXPERT_TYPE_LABELS = {
    freelancer: 'Freelancer',
    agency: 'Agency',
    app_service_provider: 'App Service',
} as const;

const EXPERT_TYPE_INDEX: Record<string, string> = EXPERT_TYPE_LABELS;

export interface ExpertTypeDisplayInput {
    type?: string | null;
    role?: string | null;
    listing_type?: string | null;
    title?: string | null;
    agency_type?: string | null;
}

export function getExpertTypeDisplay(expert: ExpertTypeDisplayInput): string {
    const type = expert.listing_type ?? expert.type ?? '';

    if (type === 'freelancer') {
        if (expert.title) return expert.title;
        if (expert.role) return expert.role;
        return EXPERT_TYPE_LABELS.freelancer;
    }

    if (expert.agency_type) {
        const agencyLabel = EXPERT_TYPE_INDEX[expert.agency_type];
        if (agencyLabel) return agencyLabel;
    }

    return EXPERT_TYPE_INDEX[type] ?? `${type.charAt(0).toUpperCase()}${type.slice(1)}`;
}
